import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 32 32' className={className} fill={fillColor}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <path
          fill={fillColor}
          d='m29.5,29l-27,0c-0.827,0 -1.5,-0.673 -1.5,-1.5l0,-6c0,-0.276 0.224,-0.5 0.5,-0.5s0.5,0.224 0.5,0.5l0,6c0,0.275 0.225,0.5 0.5,0.5l27,0c0.275,0 0.5,-0.225 0.5,-0.5l0,-6c0,-0.276 0.224,-0.5 0.5,-0.5s0.5,0.224 0.5,0.5l0,6c0,0.827 -0.673,1.5 -1.5,1.5z'
        />
        <path
          fill={fillColor}
          d='m21.5,6c-0.276,0 -0.5,-0.224 -0.5,-0.5l0,-2c0,-0.275 -0.225,-0.5 -0.5,-0.5l-9,0c-0.275,0 -0.5,0.225 -0.5,0.5l0,2c0,0.276 -0.224,0.5 -0.5,0.5s-0.5,-0.224 -0.5,-0.5l0,-2c0,-0.827 0.673,-1.5 1.5,-1.5l9,0c0.827,0 1.5,0.673 1.5,1.5l0,2c0,0.276 -0.224,0.5 -0.5,0.5z'
        />
        <path
          fill={fillColor}
          d='m27.5,21l-2,0c-0.276,0 -0.5,-0.224 -0.5,-0.5s0.224,-0.5 0.5,-0.5l2,0c1.379,0 2.5,-1.121 2.5,-2.5l0,-9.5l-26.5,0c-0.276,0 -0.5,-0.224 -0.5,-0.5s0.224,-0.5 0.5,-0.5l27,0c0.276,0 0.5,0.224 0.5,0.5l0,10c0,1.93 -1.57,3.5 -3.5,3.5z'
        />
        <path
          fill={fillColor}
          d='m6.5,21l-2,0c-1.93,0 -3.5,-1.57 -3.5,-3.5l0,-10c0,-0.276 0.224,-0.5 0.5,-0.5s0.5,0.224 0.5,0.5l0,10c0,1.379 1.121,2.5 2.5,2.5l2,0c0.276,0 0.5,0.224 0.5,0.5s-0.224,0.5 -0.5,0.5z'
        />
        <path
          fill={fillColor}
          d='m19.5,21l-7,0c-0.276,0 -0.5,-0.224 -0.5,-0.5s0.224,-0.5 0.5,-0.5l7,0c0.276,0 0.5,0.224 0.5,0.5s-0.224,0.5 -0.5,0.5z'
        />
        <path
          fill={fillColor}
          d='m9.5,23c-0.827,0 -1.5,-0.673 -1.5,-1.5l0,-3c0,-0.276 0.224,-0.5 0.5,-0.5l2,0c0.276,0 0.5,0.224 0.5,0.5l0,3c0,0.827 -0.673,1.5 -1.5,1.5zm-0.5,-4l0,2.5c0,0.275 0.225,0.5 0.5,0.5s0.5,-0.225 0.5,-0.5l0,-2.5l-1,0z'
        />
        <path
          fill={fillColor}
          d='m22.5,23c-0.827,0 -1.5,-0.673 -1.5,-1.5l0,-3c0,-0.276 0.224,-0.5 0.5,-0.5l2,0c0.276,0 0.5,0.224 0.5,0.5l0,3c0,0.827 -0.673,1.5 -1.5,1.5zm-0.5,-4l0,2.5c0,0.275 0.225,0.5 0.5,0.5s0.5,-0.225 0.5,-0.5l0,-2.5l-1,0z'
        />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
